import { StyleSheet } from 'aphrodite'

import icons from './icons'
import menu from './menu'
import button from './button'
import toolbar from './toolbar'

export default {
  icons: StyleSheet.create(icons),
  menu: StyleSheet.create(menu),
  button: StyleSheet.create(button),
  toolbar: StyleSheet.create(toolbar)
}



// WEBPACK FOOTER //
// ./src/components/partials/Editor/style/index.js